"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const extendTheme_1 = require("../extendTheme");
const lifeCycle_1 = require("../lifeCycle");
const danger = '#d70b0b';
exports.theme = extendTheme_1.extendTheme(lifeCycle_1.theme, {
    name: 'forest',
    userFriendlyName: 'Forest',
    dark: true,
    colors: {
        primary: '#024959',
        primaryText: '#FFF',
        primaryDark: '#ddd',
        danger,
        muted: '#0b586b',
        success: '#87c144',
        offline: danger,
        info: 'rgb(70, 120, 200)',
        warning: '#daa520',
        online: '#87c144',
        accent: '#F2B705',
        selected: '#F2B705',
        accentBackgroundedText: '#000',
        pageBackground: '#024959',
        pageText: '#FFF',
        cardBackground: '#027373',
        cardText: '#FFF',
        floorplans: {
            area: {
                background: '#328999',
                border: '#328999',
            },
            furniture: {
                background: '#52b9c9',
                border: '#52b9c9',
                desk: {
                    background: '#62c9d9',
                    border: '#62c9d9',
                },
                table: {
                    background: '#62c9d9',
                    border: '#62c9d9',
                },
            },
        },
        charts: {
            primary: '#4abfff',
            min: '#a1e0f8',
            neutral: '#F2B999',
            max: '#f7b2bb',
            intervalShade: '#997565',
        },
    },
});
//# sourceMappingURL=index.js.map